/* eslint-disable no-new-func, no-lonely-if */
import { FunctionFragment } from "ethers/lib/utils";
import _set from "lodash.set";
import Vue from "vue";

export default {
    methods: {
        __signSCCall(mappingObject) {
            return new Promise(resolve => {
                const result = {};
                const uiData = this.data;
                const getParentNamespace = guid => {
                    let config; let found = null;
                    let properties = this.properties[guid];
                    let { parent } = properties;

                    while (!found && parent) {
                        properties = this.properties[parent];
                        config = this.components[properties.__component];
                        if (config.namespace) {
                            found = parent;
                        } else {
                            parent = properties.parent;
                        }
                    }
                    return found;
                };

                if (mappingObject._request && mappingObject._request.active) {
                    this.__runRequestScript(mappingObject._request.content).then(resolve);
                } else {
                    if (mappingObject && mappingObject.request) {
                        Object.entries(mappingObject.request).forEach(([key, value]) => {
                            const parent = getParentNamespace(value);

                            if (parent && uiData.hasOwnProperty(parent)) {
                                const valuesList = uiData[parent];

                                result[key] = [];
                                valuesList.forEach(el => {
                                    if (el[value]) {
                                        result[key].push(el[value].value);
                                    }
                                });
                            } else if (uiData[value]) {
                                result[key] = uiData[value].value;
                            }
                        });
                    }

                    resolve(result);
                }
            });
        },
        __getResponse(mappingData, contract, result, mergeData = false) {
            const { _response = {}, response: mappingObject } = mappingData;
            const scData = result || {};
            const dataObject = this.bcResponseFormatter(contract.contract.abi, contract.method, scData);

            if (_response.active) {
                this.__runResponseScript(_response.content, dataObject);
            } else {
                const dataObject2 = this.__parseAPIData(dataObject, mappingObject);

                Object.entries(dataObject2).forEach(([key, value]) => {
                    if (value.constructor === Array) {
                        if (mergeData) {
                            const oldValues = this.data[key] || []; const mergedData = [];
                            const maxValuesLen = value.length;

                            oldValues.forEach((entry, idx) => {
                                mergedData.push({ ...entry, ...(idx < maxValuesLen ? value[idx] : {}) });
                            });
                            this.$set(this.data, key, mergedData);
                        } else {
                            this.$set(this.data, key, value);
                        }
                    } else {
                        this.$set(this.data, key, value);
                    }
                });
            }
        },
        bcResponseFieldsFormatter(responseParams, responseObj, formattedResponse = {}) {
            responseParams.forEach((param, index) => {
                const paramName = param.name || `field${index + 1}`;
                const responseParam = responseObj.hasOwnProperty(paramName) ? responseObj[paramName] : responseObj;

                if (param.baseType === "array" && Array.isArray(responseParam)) {
                    formattedResponse[paramName] = [];
                    responseParam.forEach((element) => {
                        if (param.arrayChildren.baseType === "array" || param.arrayChildren.baseType === "tuple") {
                            const arrayElement = this.bcResponseFieldsFormatter([param.arrayChildren], element);
                            formattedResponse[paramName].push(arrayElement.field1);
                        } else {
                            if (param.arrayChildren.baseType.startsWith("bytes")) {
                                // TODO convert hex string like '0x0a0e3' to string
                                formattedResponse[paramName].push(element);
                            } else {
                                formattedResponse[paramName].push(element);
                            }
                        }
                    });
                } else if (param.baseType === "tuple") {
                    formattedResponse[paramName] = this.bcResponseFieldsFormatter(param.components, responseParam);
                } else {
                    if (param.baseType.startsWith("bytes")) {
                        // TODO convert hex string like '0x0a0e3' to string
                        formattedResponse[paramName] = responseParam;
                    } else {
                        formattedResponse[paramName] = responseParam;
                    }
                }
            });

            return formattedResponse;
        },
        bcResponseFormatter(abi, methodName, responseObj) {
            const method = abi.filter(m => m.name === methodName)[0];
            const fnFrag = FunctionFragment.from(method);
            return this.bcResponseFieldsFormatter(fnFrag.outputs, responseObj);
        },
        __runResponseScript(responseScript, data = {}) {
            const localFn = new Function("response", `${responseScript};`);
            this.__executeScript({ fn: localFn }, data);
        },
        __parseAPIData(apiData = "", responseMapping = {}) {
            const bigData = {};
            const getIndexes = (path = "") => {
                const indexes = [];
                const regex = /\[(.*?)\]/gmi;
                let temp;

                // eslint-disable-next-line no-cond-assign
                while ((temp = regex.exec(path)) !== null) {
                    if (temp.index === regex.lastIndex) { regex.lastIndex++; }
                    if (temp.length) { indexes.push(temp[1]); }
                }

                return indexes;
            };
            const getParentNamespaceList = guid => {
                const segmentList = [];
                let parent = this.properties[guid] && this.properties[guid].parent ? this.properties[guid].parent : null;
                let currentProps;

                while (parent) {
                    currentProps = this.properties[parent];
                    if (this.components[currentProps.__component].namespace) {
                        segmentList.push(parent);
                    }
                    parent = currentProps.parent;
                }
                return { is: !!segmentList.length, list: segmentList.reverse() };
            };
            const parseObject = (data, path = "", fullPath = "") => {
                if (data && data.constructor === Array) {
                    data.forEach((entry, idx) => {
                        parseObject(entry, path, `${fullPath}[${idx}]`);
                    });
                } else if (data && data.constructor === Object) {
                    Object.entries(data).forEach(([key, value]) => {
                        const calcPath = path + (path ? "." : "") + key;
                        const calcFullPath = fullPath + (fullPath ? "." : "") + key;

                        parseObject(value, calcPath, calcFullPath);
                    });
                } else if (responseMapping.hasOwnProperty(path)) {
                    const mappedInput = responseMapping[path];
                    const checkNamespace = getParentNamespaceList(mappedInput);

                    if (checkNamespace.is) {
                        const mapList = []; const indexes = getIndexes(fullPath); const
                            componentList = checkNamespace.list;

                        componentList.push(mappedInput);
                        componentList.forEach((entry, idx) => {
                            mapList.push(entry);
                            if (idx < indexes.length) {
                                mapList.push(indexes[idx]);
                            }
                        });

                        _set(bigData, mapList, { value: data });
                    } else {
                        _set(bigData, mappedInput, { value: data });
                    }
                }
            };
            // const getKeys = (path = "") => path.split("[").map((key, idx) => (idx === 0 ? key : key.substring(key.indexOf(".") + 1)));

            parseObject(apiData);
            return bigData;
        },
        // eslint-disable-next-line consistent-return
        __executeCustomEventNew(guid, event, eventData, eventPath) {
            const { __customEvents } = this.properties[guid];
            const { [event]: eventCode = null } = __customEvents;

            if (eventCode) {
                const prmNames = [];
                const prmValues = [];

                Object.entries(eventData).forEach(([key, value]) => {
                    prmNames.push(key);
                    prmValues.push(value);
                });

                if (eventPath && eventPath.indexOf(",") !== -1) {
                    const [, index, ...path] = eventPath.split(",").reverse();
                    const parent = path.reverse();
                    const transform = (dataModelPath) => dataModelPath.map((item, idx) => {
                        const dot = idx === 0 ? "" : ".";
                        return /^\d+$/.test(item) ? `[${item}]` : `${dot}${this.guidToCode[item]}`;
                    }).join("");

                    parent.push(index);
                    prmNames.push("index", "path", "parent");
                    prmValues.push(index, transform(eventPath.split(",")), transform(parent));
                }

                try {
                    const fn = new Function(...prmNames, `${eventCode};`);
                    return fn.apply(this.scriptScope, prmValues);
                } catch (err) {
                    const { name, message } = err;
                    const code = guid ? this.guidToCode[guid] : null;

                    if (name || message) {
                        Vue.prototype.$toast.showNotify({
                            type: "error",
                            message: `${name ? `${name}: ` : ""}${message}${guid && code ? ` on ${code}` : ""}`,
                            code: "app-scriptErr",
                            timeout: 2000
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.log(err);
                    }
                }
            }
        }
    }
};
